import vLabel from './Label.vue';

export { vLabel };



// WEBPACK FOOTER //
// ./src/baseComponents/components/Label/index.js